import { http } from '../utils/http'

const searchEBillingAction = (params,page,size) => {
  const url = `/open/api/v1/billing/report/list?page=${page-1}&size=${size}`
  return http.post(url, params)
};
const resendAction = (params) => {
  const url = `/open/api/v1/billing/report/resend`
  return http.post(url, params)
};
const searchOrderAction = (params,page,size) => {
  const url = `/open/api/v1/order/report/list?page=${page-1}&size=${size}`
  return http.post(url, params)
};

export default {
  searchEBillingAction,
  resendAction,
  searchOrderAction,
}
